import { NavLink } from 'react-router-dom';
// mantine
import { Button } from '@mantine/core';
// icons
import { Book } from 'lucide-react';
// utils
import { TAgentPersonaToLink } from '@newo/api/gateway';

interface LinkedPersonaProps {
    persona: TAgentPersonaToLink | null;
}

const LinkedPersona = ({ persona }: LinkedPersonaProps) => {
    if (persona) {
        return (
            <div className="flex items-center gap-2">
                {persona.name}

                <Button
                    component={NavLink}
                    leftSection={<Book />}
                    size="xs"
                    title="AKB"
                    to={`/akb/${persona.id}`}
                    variant="default"
                >
                    AKB
                </Button>
            </div>
        );
    }

    return <div className="text-gray-6">n/a</div>;
};

export default LinkedPersona;
